import { useContext, useEffect, useRef } from 'react';
import { TabContext } from '../context/tabContext';

const useResizeGrid = () => {
  const { tabId } = useContext(TabContext);
  const rootWrapper = useRef<any>();
  const rootWrapperBody = useRef<any>();
  const gridBody = useRef<any>();
  const headerViewport = useRef<any>();
  const headerContainer = useRef<any>();

  const shouldResize = () => {
    rootWrapper.current =
      document.querySelector(
        '[class="ag-root-wrapper ag-layout-auto-height ag-ltr"]'
      ) ||
      document.querySelector(
        '[class="ag-root-wrapper ag-layout-auto-height ag-rtl"]'
      );
    rootWrapperBody.current = document.querySelector('[ref="rootWrapperBody"]');
    gridBody.current = document.querySelector('[ref="gridBody"]');
    headerViewport.current = document.querySelector(
      '[class="ag-header-viewport"]'
    );
    headerContainer.current = document.querySelector(
      '[ref="eCenterContainer"]'
    );

    if (rootWrapper.current) {
      let headerViewportWidth =
        headerViewport.current.getBoundingClientRect().width;
      let headerContainerWidth =
        headerContainer.current.getBoundingClientRect().width;

      if (headerViewportWidth && headerContainerWidth) {
        if (
          headerViewportWidth >= headerContainerWidth &&
          tabId === 'tabComparePinouts'
        ) {
          rootWrapper.current.style.width = 'fit-content';
          rootWrapperBody.current.style.width = 'fit-content';
          gridBody.current.style.width = 'fit-content';
        } else {
          rootWrapper.current.style.width = '';
          rootWrapperBody.current.style.width = '';
          gridBody.current.style.width = '';
        }
      }
    }
  };

  useEffect(() => {
    shouldResize();
  });

  useEffect(() => {
    shouldResize();
  }, [tabId]);
};

export default useResizeGrid;
